import { styled } from "@mui/material/styles";
import { Menu, MenuItem } from "@mui/material";

export const StyledMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    minWidth: 180,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.default,
  },
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: "12px 16px",
  justifyContent: "center",
  "&.MuiMenuItem-root": {
    color: theme.palette._components.heading.color,
    "&.Mui-focusVisible, &:hover": {
      backgroundColor: theme.palette.primary.main,
      color: "white",
    },
    "&:hover .MuiListItemIcon-root": {
      color: "white",
    },
    ".MuiListItemIcon-root": {
      color: theme.palette._components.heading.color,
      minWidth: 24,
    },
  },
}));
